import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {first} from 'rxjs/operators';
import {CustomerOverViewService} from '~features/customer-overview/customer-overview.service';
import {SpinnerService} from '~shared/components/buttons/spinner/spinner.service';
import {TablesTranslations} from '~shared/components/tables/tables-translations.service';
import {CampaignActivity, Customer, Pager} from '~core/models';
import {CampaignService, CustomerService, PaginationService} from '~core/services';


/**
 * Component that displays the campaign activity inside the customer overview
 */
@UntilDestroy()
@Component({
  selector: 'app-campaign-activity',
  templateUrl: './campaign-activity.component.html',
  styleUrls: ['../../../customer-overview.component.scss']
})
export class CampaignActivityComponent implements OnInit, OnDestroy {
  public anim: string;
  public campaignActivity: Array<CampaignActivity>;
  public pager: Pager;
  public totalData: number;
  public limitDisplayResults: number = 5;

  public columns: Array<string> = [];
  public keys: Array<Array<string>> = [];

  @Input() public spinnerName: string;
  @Input() public customer: Customer;
  @Input() public isPanelOpened: boolean = true;
  @Output() public isPanelOpenedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    public customerOverviewService: CustomerOverViewService,
    public customerService: CustomerService,
    public campaignService: CampaignService,
    public spinnerService: SpinnerService,
    public tablesTranslations: TablesTranslations,
    public paginationService: PaginationService
  ) {
  }

  public ngOnInit(): void {
    this.getCampaignActivity();
    this.campaignService.castActivity.pipe(untilDestroyed(this))
      .subscribe(act => {
        if (act !== null) {
          this.campaignActivity = act.slice(0, 5);
        }
      });

    this.columns.push(this.tablesTranslations.i18nTimestamp, this.tablesTranslations.i18nCampaignTitle, this.tablesTranslations.i18nAction);
    this.keys.push(['timestamp', 'campaignTitle', 'translatedCampaignActivityAction']);
  }

  public ngOnDestroy(): void {
  }

  /**
   * Retrieves the campaign activity and shortens it to 5 latest entries
   */
  public getCampaignActivity(): void {
    if (this.customer.hasEmail) {
      this.campaignService.getCampaignActivity(this.customer.id).pipe(first())
        .subscribe({
          next: (res: any) => {
            this.campaignService.setCampaignActivity(res);
            this.totalData = res.length;
            this.campaignService.getSubscriptionStatus(this.customer.id).pipe(first())
              .subscribe((data: any) => {
                this.customer.subscriptionStatus = data.subscriptionStatus;
                this.customer.subscriptionDatetime = data.subscriptionDatetime;
                this.customerService.setSelectedCustomer(this.customer);
                this.spinnerService.hide(this.spinnerName);
              });
          },
          error: (error: Error) => {
            this.spinnerService.hide(this.spinnerName);
          }
        });
    }
  }

  /**
   * Opens the campaign URL in a new browser tab
   */
  public openCampaignPage(event: any): any {
    if (event.campaignUrl !== null) {
      window.open(event.campaignUrl, '_blank');
    }
  }
}
